import { render, staticRenderFns } from "./VaMediaObjectFileInput.vue?vue&type=template&id=40db6042&scoped=true&"
import script from "./VaMediaObjectFileInput.vue?vue&type=script&lang=js&"
export * from "./VaMediaObjectFileInput.vue?vue&type=script&lang=js&"
import style0 from "./VaMediaObjectFileInput.vue?vue&type=style&index=0&id=40db6042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40db6042",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
